<app-header></app-header>
<div class="background-image">
<div class="container">
  <div class="row">
    <!-- Left Side: Appointment Form -->
    <div class="col-md-6">
      <div class="appointment-wrapper">
        
        <div class="appointment-form">
          <div class="form-container">
            <h3 class="form-heading">Book Your Slot</h3>

            <!-- Reactive Form -->
            <form [formGroup]="appointmentForm" (ngSubmit)="onSubmit()">
              <div class="form-group">
                <label for="name">Name:</label>
                <input formControlName="name" id="name" type="text" placeholder="Enter your name" />
                <div *ngIf="appointmentForm.get('name')?.invalid && appointmentForm.get('name')?.touched" class="error">
                  Name is required.
                </div>
              </div>

              <div class="form-group">
                <label for="email">Email:</label>
                <input formControlName="email" id="email" type="email" placeholder="Enter your email" />
                <div *ngIf="appointmentForm.get('email')?.invalid && appointmentForm.get('email')?.touched" class="error">
                  A valid email is required.
                </div>
              </div>

              <div class="form-group">
                <label for="phone">Phone/WhatsApp No:</label>
                <input formControlName="phone" id="phone" type="text" placeholder="Enter your phone/WhatsApp number" />
                <div *ngIf="appointmentForm.get('phone')?.invalid && appointmentForm.get('phone')?.touched" class="error">
                  Phone number is required.
                </div>
              </div>

              <div class="form-group">
                <label for="appointmentDate">Requested Appointment Date/Time:</label>
                <input formControlName="appointmentDate" id="appointmentDate" type="datetime-local" />
                <div *ngIf="appointmentForm.get('appointmentDate')?.invalid && appointmentForm.get('appointmentDate')?.touched" class="error">
                  Appointment date and time are required.
                </div>
              </div>

              <div class="schedule-btn">
                <button type="submit" [disabled]="appointmentForm.invalid" class="btn btn-orange">
                  Schedule Your Free Consultation
                </button>
              </div>
            </form>

            <!-- Success Message -->
            <div *ngIf="isAppointmentSubmitted" class="thank-you-message animated">
              <h3>Thank you for booking your consultation! <p>We will get back to you shortly.</p> <span class="smiley"></span></h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Side: Contact Info -->
    <div class="col-md-6">
      <div class="contact_info_sec">
        <h4>Contact Info</h4>
        <div class="info_content">
      
          <div class="info_single"><i class="fas fa-map-marker-alt"></i> Office No 254, Vision 9 Mall, Kunal Icon Road, Pimple Saudagar, Pune 411027</div>
          <div class="info_single"><i class="fas fa-phone"></i> +91 93726 56044</div>
          <div class="info_single"><i class="fas fa-envelope"></i>service&#64;snpmoney.com </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>


<section class="map_sec">
  <div class="container">
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <div class="map_inner">
          <h4>Find Us on Google Map</h4>
          <p>We are located in Pune. Find us easily on the map below!</p>
          <div class="map_bind">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.686595014192!2d73.77813967534173!3d18.58657667356044!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bff13aa2d2ef%3A0xb29d24b788f55d6c!2sVision%209%20Mall%2C%20Kunal%20Icon%20Rd%2C%20Pimple%20Saudagar%2C%20Pune%2C%20Maharashtra%20411027!5e0!3m2!1sen!2sin!4v1596988408134!5m2!1sen!2sin"
                    width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<app-footer></app-footer>
